module.exports = __webpack_public_path__ + "img/twitter.78fe852.png";